/**
 * Helper for page overlays (milestone 4): an SVG in PAGE UNITS — 1000 wide, 1000·h/w high — that
 * stretches over the page box, so normalised coordinates map as (x·1000, y·1000·h/w) at any zoom.
 */
import type { CSSProperties, ReactNode } from 'react';
import type { PageSize } from '../../shared/dto/library';

export const PAGE_UNITS_W = 1000;

export function pageUnitsHeight(page: PageSize): number {
  return page.w > 0 ? (PAGE_UNITS_W * page.h) / page.w : PAGE_UNITS_W * Math.SQRT2;
}

export function PageSvg({
  page,
  children,
  className,
  style,
}: {
  page: PageSize;
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
}) {
  const h = pageUnitsHeight(page);
  return (
    <svg
      viewBox={`0 0 ${PAGE_UNITS_W} ${h}`}
      preserveAspectRatio="none"
      className={className}
      style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', overflow: 'visible', ...style }}
    >
      {children}
    </svg>
  );
}
